import React from "react";
import { Stack, Image, Heading } from "@dgraph-io/typhoon-ui";
import { styles } from "./AppStore.styles";
import PropTypes from "prop-types";

function SampleApp({ app, onClick }) {
    return (
        <Stack
            direction="vertical"
            styles={{ marginRight: 4 }}
            key={app.name}
            onClick={onClick}
        >
            <Image
                src={app.image}
                alt={app.name}
                styles={styles.AppCardStyles}
            />

            <Heading styles={{ marginY: 3 }}>{app.name}</Heading>
        </Stack>
    );
}

SampleApp.propTypes = {
    app: PropTypes.object,
    onClick: PropTypes.func,
};

export default SampleApp;
